<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }">
    <b-modal :id="modalId" title="Mua gói" ok-title="Xác nhận" cancel-title="Đóng" size="md">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100">
          <h4>Chọn gói</h4>
        </div>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-8 offset-2">
              <b-row>
                <b-col sm="12" v-for="pck in packageList" :key="pck.id">
                  <b-card
                    img-top
                    class="iq-mb-2"
                  >
                    <b-button href="#" variant="primary" @click="buyCredit(pck)" class="col-12">
                      <i class="las la-star star-object"></i><b>{{pck.name}}</b>
                      <br>
                      <div class="d-flex justify-content-center">
                        <div class="d-flex flex-row align-items-center">
                          <i class="las la-money-bill-wave-alt" style="color: #F3C34D; font-size: 25px"></i>Mệnh giá ~ <b>{{pck.price}} USDT</b>
                        </div>
                      </div>
                    </b-button>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <contact-button/>
        <b-button variant="secondary" @click="$bvModal.hide(modalId)">Đóng</b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/store/api'
import ContactButton from '@/components/application/misc/ContactButton'

export default {
  name: 'BuyPackageModal',
  components: { ContactButton },
  data () {
    return {
    }
  },
  mounted () {
  },
  props: {
    modalId: {
      type: String,
      default: 'deposit-usdt-modal'
    },
    inputStyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          display: 'block'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      'packageList': 'Package/listState',
      'getMe': 'Auth/authUserState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    ...mapActions({
      'loadMe': 'Auth/getMe',
      'serverErrorAction': 'Setting/serverErrorAction'
    }),
    buyCredit (_package) {
      let packageId = _package.id

      this.$swal({
        title: `Xác nhận`,
        text: `Gói sẽ dc thanh toán ${_package.name}?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Mua gói',
        confirmButtonColor: '#F3C34D',
        denyButtonText: `Hủy`,
        denyButtonColor: '#A09E9E'
      }).then((result) => {
        if (result.isConfirmed) {
          api.package.buy(packageId).then((res) => {
            this.$swal({
              icon: 'success',
              title: `Mua thành công gói ${_package.name}`
            })
            this.$bvModal.hide(this.modalId)

            this.loadMe()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            }).then(() => {
              // reset
              this.serverErrorAction('')
            })
          })
        } else if (result.isDenied) {

        }
      })
    }
  }
}
</script>
